export default "__VITE_ASSET__DlrNxu_M__"